// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__T0psY","title":"Footer_title__Q8g5X","link":"Footer_link__3Ie8d"};